import * as React from "react";
import classnames from "classnames";
import { SelectionBoxRadio, Image, List } from "@grandvisionhq/common";
import { Heading, Text } from "@grandvisionhq/elements";
import { parseHtml } from "@grandvisionhq/lib-utils-html";
import { PriceTagOrIncluded } from "../../../PriceTagOrIncluded/components/PriceTagOrIncluded/PriceTagOrIncluded.js";
import { SelectionBoxTag } from "../../../SelectionBoxTag/components/SelectionBoxTag/SelectionBoxTag.js";
/* empty css                           */
const ConfiguratorRadioTile = ({
  className,
  value,
  title,
  description,
  image,
  headerRowImage,
  price,
  discountText,
  isSelected,
  uspList,
  tag,
  step,
  onChange
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: classnames("configurator-radio-tile", className, {
      "configurator-radio-tile__with-tag": !!tag
    }),
    "data-t": "configurator-radio-tile"
  },
  tag ? /* @__PURE__ */ React.createElement(SelectionBoxTag, { id: `tag-${value}`, className: "configurator-radio-tile__tag", title: tag }) : null,
  /* @__PURE__ */ React.createElement(
    SelectionBoxRadio,
    {
      className: "configurator-radio-tile__radio",
      name: "configurator-radio-tile",
      value,
      checked: isSelected,
      onChange: () => onChange(value),
      "aria-describedby": tag ? `tag-${value}` : void 0,
      "data-t": "configurator-radio-tile-radio"
    },
    /* @__PURE__ */ React.createElement("div", { className: "configurator-radio-tile__wrapper" }, image && /* @__PURE__ */ React.createElement(Image, { className: "configurator-radio-tile__image", cover: true, alt: "", url: image }), /* @__PURE__ */ React.createElement("div", { className: "configurator-radio-tile__body" }, /* @__PURE__ */ React.createElement("div", { className: "configurator-radio-tile__heading" }, /* @__PURE__ */ React.createElement("div", { className: "configurator-radio-tile__heading-wrapper" }, headerRowImage && /* @__PURE__ */ React.createElement(
      Image,
      {
        className: "configurator-radio-tile__row-image",
        cover: false,
        url: headerRowImage,
        alt: ""
      }
    ), /* @__PURE__ */ React.createElement(
      Heading,
      {
        className: "configurator-radio-tile__subheading1",
        component: "div",
        variant: "subheading1",
        visualHeadingOnly: true,
        "data-t": "configurator-radio-tile-title"
      },
      title
    )), price && /* @__PURE__ */ React.createElement(PriceTagOrIncluded, { ...price, discountText, step })), description && /* @__PURE__ */ React.createElement(
      Text,
      {
        className: "configurator-radio-tile__description",
        "data-t": "configurator-radio-tile-description"
      },
      parseHtml(description)
    ), uspList && /* @__PURE__ */ React.createElement(
      List,
      {
        items: uspList,
        spacing: "compact",
        renderText: (item) => /* @__PURE__ */ React.createElement(Text, { variant: "caption" }, item),
        className: "configurator-radio-tile__usp-list"
      }
    )))
  )
);
export {
  ConfiguratorRadioTile
};
//# sourceMappingURL=ConfiguratorRadioTile.js.map
